var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"margin-top-20",attrs:{"gutter":30}},[(_vm.data1)?_c('el-col',{staticClass:"f16 dark-1",attrs:{"span":12}},[_vm._v(" 21212 ")]):_vm._e(),_c('el-col',{attrs:{"span":12}},[_c('lee-bar-echarts',{ref:"bar1",attrs:{"height":"200px","width":"512px","show-legend":false,"show-right":false,"bar-width":20}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }